export default function Marquee({ items, dark = false }) {
  const row = [...items, ...items];
  return (
    <div
      className={`marquee border-y ${dark ? "border-paper/15 text-tortora" : "border-ink/10 text-tortora"}`}
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-baseline font-mono text-xs uppercase tracking-[0.35em]"
          >
            <span className="py-6">{item}</span>
            <span className="mx-8 text-bordeaux">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
